import 'rsvp';
import '@ember/runloop';
import '@ember/application';
import '@ember/service';
import { animate } from '../animate.js';
import '@ember/array';
import '@ember/object/internals';
import '../constraints.js';
import '../mutation-observer.js';
import '../velocity-ext.js';

function scale(opts = {}) {
  return animate(this.oldElement, {
    scale: [0.2, 1]
  }, opts).then(() => {
    return animate(this.newElement, {
      scale: [1, 0.2]
    }, opts);
  });
}

export { scale as default };
//# sourceMappingURL=scale.js.map
